module.exports = {"id":"143001","name":"Carlos Tévez","rating":"78","photo":"./data/images/photos/0/143001.png","club":{"name":"Boca Juniors","logo":"./data/images/clubs/BocaJuniors.png"},"positions":["MOC","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosTevez0.json
// module id = 728
// module chunks = 0